module.exports = __webpack_public_path__ + "static/media/history.808e21cf.svg";